import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
// import { CustomerGetAction, CustomerStatusAction } from '../../Redux/Action/CustomerAction';
import { CategoryAddAction, CategoryGetAction } from "../../Redux/Action/Category";
import { toast } from "react-toastify";
import { imageExtentionSupport } from "../../utils/Helper";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { FaqCrateaAction } from "../../Redux/Action/FaqAction";




interface FormInputs {
  answer: string,
  question: string,
  user_type: string,

}
function FaqManagementAdd() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate()
  const log_in = useSelector((state: any) => state.AdminLogInState)
  const faqstatus  = useSelector((state:any)=>state.FaqCreatestate)
  const [loading , setLoading] = useState(false)

  const formSchema: any = Yup.object().shape({
    question: Yup.string()
      .required('Please enter question.')
      .trim()
      .min(2, 'question must be more than 2 characters.')
      .max(255, 'question should not exceed 50 characters.'),

    answer: Yup.string()
      .required('Please enter answer.')
      .trim()
      .min(2, 'Answer be more than 2 characters.')
      .max(255, 'question should not exceed 50 characters.'),

    user_type: Yup.string()
      .required('Please enter user type.')
      .trim()


  });
  const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });
  const onSubmit = (data: FormInputs) => {
    setLoading(true)
    dispatch(FaqCrateaAction(data))
  };
  useEffect(()=>{
  if(faqstatus.status){
    setTimeout(() => {
      navigate("/faq-list")
    }, 1000);
  }
  },[faqstatus])

  useEffect(() => {
        return () => {
            dispatch(FaqCrateaAction('RESET'));
        }
  }, [])
  return (
    <Fragment>
      {log_in?.loading || loading ? <Spinner /> : ""}
      <PageLayout
        title="Faq Add"
        breadcrumbs={{
          secLast: { 'link': '/faq-list', 'name': 'Faq' },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >


        <div className="mt-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4 mb-4 align-items-end">
              <div className="col-md-6">
                <label htmlFor="username" className="form-label">Question</label>
                <input type="text" className="form-control mb-0" id="question" placeholder="Enter Question" {...register("question", {
                  required: "Please enter question.",

                })}
                  onInput={(e: any) => {
                    // e.target.value = e.target.value.replace(/\s/g, '');
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="question"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="username" className="form-label">Answer</label>
                <input type="text" className="form-control mb-0" id="answer" placeholder="Enter Answer" {...register("answer", {
                  required: "Please enter answer.",

                })}
                  onInput={(e: any) => {
                    // e.target.value = e.target.value.replace(/\s/g, '');
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="answer"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="user_type" className="form-label">User Type</label>
                <select
                  id="user_type"
                  className="form-control profile-approve-dropdown mb-0"
                  {...register("user_type", {
                    required: "Please select a user type."
                  })}
                >
                  <option value="">Select User Type</option>
                  <option value="Salon">Salon</option>
                  <option value="Customer">Customer</option>
                </select>
                <ErrorMessage
                  errors={errors}
                  name="user_type"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <button type="submit" className="btn btn-primary waves-effect waves-light w-100">SAVE</button>
              </div>
            </div>

          </form>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default FaqManagementAdd